import { render, staticRenderFns } from "./Wedding.vue?vue&type=template&id=05f926f2&scoped=true"
import script from "./Wedding.vue?vue&type=script&lang=js"
export * from "./Wedding.vue?vue&type=script&lang=js"
import style0 from "./Wedding.vue?vue&type=style&index=0&id=05f926f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f926f2",
  null
  
)

export default component.exports